angular.module('services.newman.CasesService', [
  'global'
])

/**
 * The CasesService service stores methods used to access
 * system APIs.
 *
 * @class CasesService
 * @constructor
 * @module services.newman.CasesService
 */
.factory('CasesService', [
  'ModelsService',
  function (ModelsService) {
    'use strict';

    var service = {

      cases: [],

      queue: [],

      /**
       * Returns cases.  If a caseId is
       * provided will return a single case.  If no
       * caseId is provided will return all cases.
       *
       * @param {string} [caseId] - param to return only a specific case
       * @return {Object|Array<Object>} All entries
       */
      get: function get(caseId) {
        service.cases = ModelsService.read('cases');

        if (caseId) {
          return _.find(service.cases, { id: caseId });
        }

        return service.cases;
      },

      /**
       * Creates a new case with provided data
       *
       * @param {Object} data - Case data
       * @return {Promise<Object>} new case
       */
      create: function create(data) {
        return ModelsService.create(ModelsService.find('endpoints', 'label', 'cases'), data);
      },

      /**
       * Updates an existing case with provided data
       *
       * @param {string} id - Case id
       * @param {Object} data - Case data
       * @return {Promise<Object>} updated case
       */
      update: function update(id, data) {
        return ModelsService.update(ModelsService.find('cases', 'id', id), data);
      },

      /**
       * Removes an existing case
       *
       * @param {string} id - Case id
       * @return {Promise<Object>} copy of deleted case
       */
      remove: function remove(id) {
        return ModelsService.remove(ModelsService.find('cases', 'id', id));
      },

      /**
       * Adds a relative to a case
       *
       * @param {Object} caseRef - The case to be added to
       * @param {Object} relative - The relative to be added
       * @return {Promise<Object>} Updated case
       */
      addRelative: function addRelative(caseRef, relative) {
        var model = {
          relatives: caseRef.relatives,
          content: caseRef.content
        };

        model.relatives = service.rejectRelative(model.relatives, relative.id);

        model.relatives = service.createRelative(model.relatives, relative);

        // If start is not set and relative is a state, add as start
        if ((typeof model.content.start === 'undefined' || model.content.start === '') && relative.model === 'states') {
          model.content.start = relative.id;
        }

        return ModelsService.update(caseRef, model);
      },

      /**
       * Removes a relative from a case
       *
       * @param {Object} caseRef - The case to be removed from
       * @param {Object} relative - The relative to be removed
       * @return {Promise<Object>} Updated case without relative
       */
      removeRelative: function removeRelative(caseRef, relative) {
        var model = {
          relatives: caseRef.relatives,
          content: caseRef.content
        };

        model.relatives = service.rejectRelative(model.relatives, relative);

        // if the relative being removed is the starting state, update the start property in content
        if (relative === caseRef.content.start) {
          model.content.start = '';
        }

        return ModelsService.update(caseRef, model);
      },

      /**
       * Creates a new relative object
       *
       * @param {Array<Object>} relatives - Collection of relatives
       * @param {Object} data - Properties for new relative
       * @return {Array<Object>} Updated collection of relatives
       */
      createRelative: function createRelative(relatives, data) {
        var relative = {};

        relative.id = data.id;
        relative.label = data.label;
        relative.model = data.model;
        relative.href = 'http://localhost:4242/api/v1/' + data.model + '/' + data.id;
        relative.classes = [data.model];

        relatives.push(relative);

        return relatives;
      },

      /**
       * Removes a relative from collection based on id
       *
       * @param {Array<Object>} relatives - Collection of relatives
       * @param {string} id - ID of relative to remove
       * @return {Array<Object>} Updated collection of relatives
       */
      rejectRelative: function rejectRelative(relatives, id) {
        return _.reject(relatives, { id: id });
      },

      /**
       * Updates a case with the provided list of relatives
       *
       * @param {Object} caseRef - Case reference
       * @param {Array<Object>} relatives - Collection of relatives
       * @return {Promise<Object>} Updated case
       */
      updateRelatives: function updateRelatives(caseRef, relatives) {
        var model = {
          relatives: relatives
        };

        return ModelsService.update(caseRef, model);
      }
    };

    return service;
  }
]);
